import { css, etiColors, mediaQueries } from '@eti/styles';
import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';

const numberOfSeatsInfoStyles = css`
  background-color: ${etiColors.warning.solid};
  border-radius: 15px;
  bottom: -9px;
  color: ${etiColors.white};
  display: flex;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 9px;
  position: absolute;
  right: 10px;
  text-align: center;
  z-index: 1;

  [dir='rtl'] & {
    left: 10px;
    right: auto;
  }

  @media ${mediaQueries.large.up} {
    bottom: -11px;
    font-size: 0.875rem;
    padding: 3px 11px;
    right: 20px;
    [dir='rtl'] & {
      left: 20px;
      right: auto;
    }
  }
`;

const UrgencyFlag = ({ numberOfSeatsLeft }) => {
  const { t } = useTranslation();
  const text =
    numberOfSeatsLeft > 1
      ? t('Air.Result.NumberOfSeatsLeft', numberOfSeatsLeft)
      : t('Air.Result.OneSeatLeft', numberOfSeatsLeft);

  return (
    <div className={numberOfSeatsInfoStyles} data-testid="resultPage-urgencyFlag">
      {text}
    </div>
  );
};

UrgencyFlag.propTypes = {
  numberOfSeatsLeft: PropTypes.number,
};

export default UrgencyFlag;
